/**
 * Do not use this to clone typed objects.
 * @see instead app/shared/models/copy-constructable
 *
 * @param it
 * @param {boolean} includeFunctions - copy function references
 * @param {number} maxDepth - max object depth allowed (guard against infinite recursion)
 * @param root
 * @returns {any}
 */
export function cloneDeep(
  it: any,
  includeFunctions = true,
  maxDepth = 20,
  root: any = it,
): any {
  let copy: any;

  if (maxDepth < 0) {
    throw new Error('clone depth exceeded by ' + JSON.stringify(root));
  }

  if (typeof it !== 'object') {
    return it;
  }

  if (!it) {
    return it;
  }

  if (typeof it.length === 'number') {
    copy = [];
    for (let i = 0; i < it.length; i += 1) {
      copy[i] = cloneDeep(it[i], includeFunctions, maxDepth - 1, root);
    }
    return copy;
  }

  if (it instanceof Date) {
    return new Date(it) as any;
  }

  // use the object's own copy implementation if it exists.
  // In case this is used top-level to clone a class instance.
  if (
    typeof it === 'object' &&
    typeof it.copy === 'function' &&
    it instanceof it.constructor
  ) {
    copy = it.copy();
    if (copy instanceof it.constructor) {
      return copy;
    }
  }

  copy = {};
  for (const i in it) {
    if (
      it.hasOwnProperty(i) ||
      (includeFunctions && typeof it[i] === 'function')
    ) {
      copy[i] = cloneDeep(it[i], includeFunctions, maxDepth - 1, root);
    }
  }
  return copy;
}
